<template>
    <a-card>
        <a-tabs v-model:activeKey="activeKey" @change="activeChange">
            <a-tab-pane key="1" tab="资质"><qualification :activeValue="activeValue"/></a-tab-pane>
            <a-tab-pane key="2" tab="荣誉" force-render><honorList :activeValue="activeValue"/></a-tab-pane>
        </a-tabs>
    </a-card>

</template>
<script>
import qualification from "./qualification"
import honorList from "./honorList"

export default {
    name: "index",
    components: {qualification,honorList},
    data() {
        return {
            activeKey:'1',
            activeValue:""
        }
    },
    mounted() {
    },
    methods:{
        activeChange(val){
            console.log(val)
                this.activeValue = val
        }
    }

}
</script>
